export default "__VITE_ASSET__Ynu8L3N9__"